import React from 'react'
import cx from 'classnames'

export default class Toggle extends React.PureComponent {
  renderOption({ text, value }) {
    const checked = this.props.selected === value
    const className = cx('toggle__option', {
      '-checked': checked
    })

    const inputProps = {
      checked,
      key: value,
      name: this.props.name,
      onChange: this.props.onChange,
      value
    }

    return (
      <span className={className} key={value}>
        <input id={text} type="radio" {...inputProps} />
        <label className="toggle__option__label" htmlFor={text}>
          {text}
        </label>
      </span>
    )
  }

  render() {
    return (
      <fieldset>
        <legend className="screenreader-only">{this.props.label}</legend>
        <span className="toggle">
          {this.props.options.map(this.renderOption, this)}

          <span className="toggle__suffix type-subtitle" aria-hidden="true">
            {this.props.suffix}
          </span>
        </span>
      </fieldset>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/toggle.js